var _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 46.6871V12H50V46.6871H0ZM28.8959 24.9947H34.1942C32.8063 22.0819 29.9926 19.3219 26.952 19C27.7402 20.5091 28.5683 22.6303 28.8959 24.9947ZM26.855 21.8389C26.2238 19.9155 25.4685 19.0546 25.0001 19.0546C24.5316 19.0546 23.7764 19.9155 23.1451 21.8389C22.8404 22.767 22.5965 23.8339 22.4188 24.9945H27.5812C27.4036 23.834 27.1596 22.767 26.855 21.8389ZM22.0754 29.0268C22.0754 30.0462 22.1202 31.0422 22.205 31.997H27.795C27.8798 31.0422 27.9246 30.0462 27.9246 29.0268C27.9246 28.0075 27.8798 27.0114 27.795 26.0567H22.205C22.1202 27.0114 22.0754 28.0075 22.0754 29.0268ZM23.1452 36.2157C23.7764 38.1391 24.5316 39 25.0001 39C25.4685 39 26.2237 38.1391 26.855 36.2157C27.1596 35.2875 27.4035 34.2206 27.5812 33.0599H22.4189C22.5966 34.2206 22.8405 35.2876 23.1452 36.2157ZM15 29.027C15 27.9968 15.1445 27.0002 15.4133 26.0568H20.9731C20.8907 27.0313 20.8489 28.0299 20.8489 29.027C20.8489 30.024 20.8906 31.0227 20.9731 31.9971H15.4133C15.1445 31.0536 15 30.0572 15 29.027ZM29.0269 26.0568H34.5867C34.8555 27.0002 35 27.9968 35 29.027C35 30.0572 34.8555 31.0537 34.5867 31.9971H29.0269C29.1093 31.0227 29.1511 30.024 29.1511 29.027C29.1511 28.0299 29.1093 27.0313 29.0269 26.0568ZM23.1879 19C22.3997 20.509 21.4317 22.6302 21.1041 24.9947H15.8058C17.1938 22.082 19.8067 19.5719 23.1879 19ZM21.1041 33.0599H15.8058C17.1938 35.9728 19.7457 38.5177 22.9466 39C22.1583 37.4908 21.4317 35.4243 21.1041 33.0599ZM26.952 39C27.7402 37.491 28.5683 35.4244 28.8959 33.0599H34.1942C32.8063 35.9728 29.7454 38.3821 26.952 39Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M50 10.338V3H0V10.338H50Z",
    opacity: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.433,
    cy: 6.799,
    r: 1.478,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.358,
    cy: 6.799,
    r: 1.478,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.7c6273ecfee4a1592b5ea513deccaa55.svg";
export { ForwardRef as ReactComponent };